import React, { Fragment } from "react";
import { Route, Navigate } from "react-router-dom";
import ExecutiveDashboard from "../pages/platform/dashboard/ExecutiveDashboard";
import OperationsCockpit from "../pages/platform/dashboard/OperationsCockpit";
import AlertCenter from "../pages/platform/dashboard/AlertCenter";
import TenantList from "../pages/platform/tenants/TenantList";
import TenantDetail from "../pages/platform/tenants/TenantDetail";
import CreateTenantWizard from "../pages/platform/tenants/CreateTenantWizard";
import SupportMode from "../pages/platform/tenants/SupportMode";
import PlanCatalog from "../pages/platform/subscriptions/PlanCatalog";
import TenantSubscriptions from "../pages/platform/subscriptions/TenantSubscriptions";
import RenewalCalendar from "../pages/platform/subscriptions/RenewalCalendar";
import UsageOverview from "../pages/platform/usage/UsageOverview";
import QuotaPolicies from "../pages/platform/usage/QuotaPolicies";
import OverageReview from "../pages/platform/usage/OverageReview";
import ConnectorHealthBoard from "../pages/platform/integrations/ConnectorHealthBoard";
import IntegrationDetail from "../pages/platform/integrations/IntegrationDetail";
import WebhookMonitor from "../pages/platform/integrations/WebhookMonitor";
import JobQueue from "../pages/platform/jobs/JobQueue";
import FailureDetail from "../pages/platform/jobs/FailureDetail";
import RetryCenter from "../pages/platform/jobs/RetryCenter";
import TemplateLibrary from "../pages/platform/templates/TemplateLibrary";
import TemplateEditor from "../pages/platform/templates/TemplateEditor";
import TemplateVersions from "../pages/platform/templates/TemplateVersions";
import PolicyList from "../pages/platform/ai-policies/PolicyList";
import PromptEditor from "../pages/platform/ai-policies/PromptEditor";
import ModelRouting from "../pages/platform/ai-policies/ModelRouting";
import AuditExplorer from "../pages/platform/audit/AuditExplorer";
import SecurityCenter from "../pages/platform/audit/SecurityCenter";
import AccessReviews from "../pages/platform/audit/AccessReviews";
import BillingDashboard from "../pages/platform/billing/BillingDashboard";
import Invoices from "../pages/platform/billing/Invoices";
import PaymentIssues from "../pages/platform/billing/PaymentIssues";
import TicketConsole from "../pages/platform/support/TicketConsole";
import TenantSupportView from "../pages/platform/support/TenantSupportView";
import Runbooks from "../pages/platform/support/Runbooks";
import GeneralSettings from "../pages/platform/settings/GeneralSettings";
import FeatureFlags from "../pages/platform/settings/FeatureFlags";
import StorageRetention from "../pages/platform/settings/StorageRetention";
import NotFoundPage from "../pages/shared/NotFoundPage";
import AuditLogs from "../pages/Auditlogs/Auditlogs";
import MeetingList from "../pages/company/meetings/MeetingList";

const meetingHubPlatformRoutes = (
  <Fragment>
    <Route index element={<Navigate to="dashboard" replace />} />
    <Route path="dashboard/cockpit" element={<OperationsCockpit />} />
    <Route path="dashboard/alerts" element={<AlertCenter />} />
    <Route path="dashboard" element={<ExecutiveDashboard />} />
    <Route path="tenants/create" element={<CreateTenantWizard />} />
    <Route path="tenants/:id/support" element={<SupportMode />} />
    <Route path="tenants/:id" element={<TenantDetail />} />
    <Route path="tenants" element={<TenantList />} />
    <Route path="subscriptions/renewals" element={<RenewalCalendar />} />
    <Route path="subscriptions/plans" element={<PlanCatalog />} />
    <Route path="subscriptions" element={<TenantSubscriptions />} />
    <Route path="usage/overage" element={<OverageReview />} />
    <Route path="usage/quotas" element={<QuotaPolicies />} />
    <Route path="usage" element={<UsageOverview />} />
    <Route path="integrations/webhooks" element={<WebhookMonitor />} />
    <Route path="integrations/:provider" element={<IntegrationDetail />} />
    <Route path="integrations" element={<ConnectorHealthBoard />} />
    <Route path="jobs/retry" element={<RetryCenter />} />
    <Route path="jobs/:id" element={<FailureDetail />} />
    <Route path="jobs" element={<JobQueue />} />
    <Route path="meetings" element={<MeetingList />} />
    <Route path="templates/new" element={<TemplateEditor />} />
    <Route path="templates/:id/versions" element={<TemplateVersions />} />
    <Route path="templates/:id" element={<TemplateEditor />} />
    <Route path="templates" element={<TemplateLibrary />} />
    <Route path="ai-policies/routing" element={<ModelRouting />} />
    <Route path="ai-policies/:id" element={<PromptEditor />} />
    <Route path="ai-policies" element={<PolicyList />} />
    <Route path="audit/access-reviews" element={<AccessReviews />} />
    <Route path="audit/security" element={<SecurityCenter />} />
    <Route path="audit" element={<AuditLogs />} />
    <Route path="billing/invoices" element={<Invoices />} />
    <Route path="billing/payment-issues" element={<PaymentIssues />} />
    <Route path="billing" element={<BillingDashboard />} />
    <Route path="support/tenant-view" element={<TenantSupportView />} />
    <Route path="support/runbooks" element={<Runbooks />} />
    <Route path="support" element={<TicketConsole />} />
    <Route path="settings/flags" element={<FeatureFlags />} />
    <Route path="settings/retention" element={<StorageRetention />} />
    <Route path="settings" element={<GeneralSettings />} />
    <Route path="*" element={<NotFoundPage />} />
  </Fragment>
);

export default meetingHubPlatformRoutes;
